<template>
  <div v-loading="pageLoad" class="portlet">
    <div class="id-info">
        <input ref="img1" style="visibility: hidden;" type="file" @change="uploadCard1($event)"/>
        <input ref="img2" style="visibility: hidden;" type="file" @change="uploadCard2($event)"/>
        <div class="item">
            <span class="title">报考级别：</span>
            <span class="ver-info">{{textObj[Number(level)]}}</span>
        </div>
        <div class="pic-content">
            <div v-loading="card1Load" class="img-c img1" @click="uploadImg(1)">
                <i class="fa icon-add-select" style="font-weight: bold;
    padding-top: 28px;display: inline-block;"/><br>
                <span>个人近照<br>（二寸蓝底）</span>
                <img v-if="card1Url" :src="card1Url">
            </div>
            <div class="r-content">
                <select v-model="type" @change="changeSelect">
                    <option value ="1">学历证明</option>
                    <option value ="2">资格证明</option>
                    <option value ="3">工作证明</option>
                </select>
                <div v-loading="card2Load" class="img-c img2" @click="uploadImg(2)">
                    <i class="fa icon-add-select" style="font-weight: bold;
        padding-top: 70px;display: inline-block;"/><br>
                    <span>学历证明</span>
                    <img v-if="card2Url" :src="card2Url">
                </div>
            </div>
        </div>
        
    </div>
    <div class="step-btn" style="margin-bottom:20px" @click="next">提  交
        <!-- <i class="fa icon-arrow-right"/> -->
    </div>
  </div>
</template>
<script>
export default {
    props:{
        level:{
            type:Number,
            default: () => 1,
        }
    },
    data() {
        return {
            pageLoad: false,
            card1Load: false,
            card2Load: false,
            card1Url: '',
            card2Url: '',
            uploadCard1Success:false,
            uploadCard2Success:false,
            type:1,
            textObj:{
                0:'EIFM 初级国际财务管理师',
                1:'AIFM 助理级国际财务管理师',
                2:'IFM 中级国际财务管理师',
                3:'SIFM 高级国际财务管理师',
                4:'继续教育',
            }
        }
    },
    mounted() {
    },
    methods: {
        async next(){
            if(!this.card1Url){
                this.$toast('请上传个人近照');
                return false;
            }else if(!this.card2Url){
                switch (Number(this.type)) {
                    case 1:
                        this.$toast('请上传学历证明');
                        break;
                    case 2:
                        this.$toast('请上传资格证明');
                        break;
                    default:
                        this.$toast('请上传工作证明');
                        break;
                }
                return false;
            }
            const param = {
                latest_photo:this.card1Url,
                certificate_type:this.type,
                certificate_photo:this.card2Url,
                type: Number(this.level),
                token:localStorage.getItem('ifm_token'),
            };
            try {
                const res = await this.$http.post('/api/user/submitInfo',param);
                if(res){
                    this.$emit('changeStep',5);
                }
                
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
        },
        changeSelect(){
            this.uploadCard2Success = false;
            this.card2Url = '';
        },
        uploadImg(val){
            console.log('uploadImg', val);
            if(val === 1){
                this.$refs.img1.click();
            }else{
                this.$refs.img2.click();
            }
        },
        async uploadCard1(e){
            const imgFile = e.target.files[0];
            const formData = new FormData();
            formData.append('file', imgFile);
            this.card1Load = true;
            try {
                const res = await this.$http.post('/api/user/uploadIdCard',formData);
                this.card1Load = false;
                if(res){
                    this.card1Url = res.url;
                }
            } catch (error) {
                this.card1Load = false;
                this.$toast(error.message||'请求失败');
            }

        },
        async uploadCard2(e){
            const imgFile = e.target.files[0];
            const formData = new FormData();
            formData.append('file', imgFile);
            this.card2Load = true;
            try {
                const res = await this.$http.post('/api/user/uploadIdCard',formData);
                this.card2Load = false;
                if(res){
                    this.card2Url = res.url;
                }
            } catch (error) {
                this.card2Load = false;
                this.$toast(error.message||'请求失败');
            }
            
        },
    },
}
</script>
<style lang="scss" scoped>
@import '../../assets/user.scss';
.id-info{
    width:100%;
    padding-left: 15px;
    .item{
        margin-bottom: 25px;
        span{
            display: inline-block;
            vertical-align: middle;
        }
        .title{
            text-align: right;
            width: 75px;
        }
        .ver-info{
            width: 230px;
            height: 30px;
            line-height: 28px;
            margin-left: 5px;
            font-size: 16px;
            font-weight: 500;
        }
    }
}
.pic-content{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .img-c{
        background-color: #f0f0f0;
        position: relative;
        text-align: center;
        font-size: 12px;
    }
    .img1{
        width: 90px;
        height: 119px;
        line-height: 19px;
        color: #989696;
        img{
            position: absolute;
            z-index: 999;
            top:0px;
            left: 0px;
            width: 90px;
            height: 119px;
        }
    }
    .img2{
        width: 347px;
        min-height: 180px;
        line-height: 19px;
        color: #989696;
        img{
            // position: absolute;
            z-index: 999;
            top:0px;
            left: 0px;
            width: 347px;
        }
    }
}
.r-content{
    width: 385px;
    select{
        border: 1px solid #d1d0d0;
        width: 88px;
        height: 24px;
        margin-bottom: 10px;
    }
}
</style>
